interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  head: string;
  message: string;
}

function AlertModal({ isOpen, onClose, head, message }: ModalProps) {
  if (!isOpen) return null; // 모달이 열려있지 않으면 아무것도 렌더링하지 않음

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="bg-bg_modal_popup w-[320px] rounded-lg pb-[16px] pt-[32px] text-base font-medium leading-5">
        {/* {head && <h2 className="mb-[24px] text-[18px] font-bold">{head}</h2>} */}
        <p className="whitespace-pre-wrap px-4 text-center text-[17px] font-medium leading-5 text-white">{message}</p>
        {onClose && (
          <div className="mt-[24px] flex justify-between space-x-2 px-[16px]">
            <button
              onClick={onClose}
              className="h-[48px] w-full rounded-[8px] bg-white py-3 text-base font-semibold leading-5 text-btText transition"
            >
              확인
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AlertModal;
